import {
  WSEmptyState,
  WSMarginProps,
  WSTable,
  WSTableCell,
  WSTableColumn
} from "@wingspanhq/fe-component-library";
import { IWorkDefinition } from "@wingspanhq/payments/dist/interfaces";
import React, { useMemo } from "react";
import { useModalWorkDefinitionDetails } from "../../modals/ModalWorkDefinitionDetails/useModalWorkDefinitionDetails";
import { selectorFieldCounts } from "../../selectors/selectorFieldCounts";

export interface TableWorkDefinitionsProps extends WSMarginProps {
  workDefinitions: IWorkDefinition[];
}

export const TableWorkDefinitions: React.FC<TableWorkDefinitionsProps> = ({
  workDefinitions,
  ...elementProps
}) => {
  const modalWorkDefinitionDetails = useModalWorkDefinitionDetails();
  const tableData = useMemo(() => {
    return workDefinitions.map(workDefinition => ({
      id: workDefinition.workDefinitionId,
      data: workDefinition
    }));
  }, [workDefinitions]);

  const columns: Array<WSTableColumn<IWorkDefinition>> = [
    {
      config: {
        gridTemplateSizeMax: "auto",
        header: {
          text: "Work type"
        }
      },

      renderFunction: rowItem => (
        <WSTableCell
          text={rowItem.data.name}
          secondaryText={rowItem.data.description}
        />
      )
    },
    {
      config: {
        header: {
          text: "Fields"
        },
        hideOnScreens: ["XS"]
      },
      renderFunction: rowItem => {
        const counts = selectorFieldCounts(rowItem.data.attributeDefinitions);

        return (
          <WSTableCell
            text={
              counts.required > 0
                ? `${counts.required} required fields`
                : "No fields"
            }
            secondaryText={
              counts.optional > 0
                ? `${counts.optional} optional fields`
                : undefined
            }
          />
        );
      }
    }
  ];

  if (tableData.length === 0) {
    return (
      <WSEmptyState
        type="documents"
        title="No work definitions"
        description="There are no work definitions configured."
        hasBorder={true}
        bgColor="gray"
        orientation="horizontal"
      />
    );
  }

  return (
    <WSTable<IWorkDefinition>
      {...elementProps}
      tableData={tableData}
      columns={columns}
      onRowClick={item =>
        modalWorkDefinitionDetails.open({ workDefinition: item.data })
      }
      data-testid="workDefinitionsTable"
    />
  );
};
